import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { IgDialog } from "@intelligems/ig-theme";
import { ExperienceListDto, GenericExperienceFe } from "@intelligems/ig-types";
import { EXPERIMENT_ROUTES } from "@src/routes/routes";

import { useDeleteExperience } from "../../api/experience-actions/delete-experience";
import { isDialogOpen, setDialog } from "../../store/slices/global";

interface ConfirmExperimentDeleteDialogProps {
  currentExperience: Omit<
    Pick<ExperienceListDto, "testTypes" | "name">,
    "id"
  > & { id?: string };
  redirect: boolean;
}
export const ConfirmExperienceDeleteDialog = ({
  currentExperience,
  redirect,
}: ConfirmExperimentDeleteDialogProps) => {
  const isOpen = useSelector(isDialogOpen("confirmExperimentDeletion"));
  const navigate = useNavigate();

  const deleteExperience = useDeleteExperience(currentExperience, "experiment");

  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(setDialog({ dialog: "confirmExperimentDeletion", open: false }));
  };

  const onYesClick = () => {
    deleteExperience.mutate({
      body: { variationId: undefined },
      queryParams: undefined,
      pathParams: {
        experienceId: currentExperience.id!,
        action: "delete",
      },
    });
    if (redirect) {
      void navigate(EXPERIMENT_ROUTES.Experiments);
    }
    handleClose();
  };

  useEffect(() => {
    if (deleteExperience.isSuccess) {
      deleteExperience.reset();
    }
  }, [deleteExperience]);

  return (
    <IgDialog
      title={currentExperience.name}
      subtitle={"Are you sure you want to delete this test?"}
      handleClose={handleClose}
      showDialog={isOpen}
      handleYesClick={onYesClick}
      yesButtonText={"Yes, delete this test"}
      loading={deleteExperience.isPending}
      shouldNotClose={true}
      dialogHeight={null}
    />
  );
};
